module.exports = __webpack_public_path__ + "static/media/fourteenth_the_inn2.07a19d6b.jpg";